import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, memo } from 'react';
import UIPercentageInput from 'UIComponents/input/UIPercentageInput';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { parseNumericValue } from '../utils/parseNumericValue';
import { isProbability } from 'customer-data-objects/property/PropertyIdentifier';
// Values of properties with `numberDisplayHint=probability` are restricted to the range `[0, 1]`.
// Values of properties with `numberDisplayHint=percentage` are not restricted.
const PROBABILITY_ALLOWED_RANGE_PROPS = {
  min: 0,
  max: 100
};

const PropertyInputPercentage = props => {
  const {
    value,
    onChange,
    inputRef,
    property
  } = props;
  const handleChange = useCallback(evt => {
    if (typeof onChange === 'function') {
      // UIPercentageInput's onChange sends `number | null`; convert to `string | null`
      onChange(evt.target.value == null ? evt : SyntheticEvent(String(Number(evt.target.value) / 100)));
    }
  }, [onChange]);
  const numericValue = parseNumericValue(value);
  const percentageValue = numericValue === null ? null : numericValue * 100;
  const allowedRangeProps = isProbability(property) ? PROBABILITY_ALLOWED_RANGE_PROPS : undefined;
  return /*#__PURE__*/_jsx(UIPercentageInput, Object.assign({}, getTransferrableProps(props), {
    onChange: handleChange,
    inputRef: inputRef // @ts-expect-error UIPercentageInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: percentageValue
  }, allowedRangeProps, {
    precision: 2
  }));
};

export default /*#__PURE__*/memo(PropertyInputPercentage);